import React from "react";

const steps = [
  { n: "01", title: "Send Funds", desc: "A user sends funds from their wallet or bank account to a decentralized-managed vault at the origin point." },
  { n: "02", title: "Validator Consensus", desc: "Cahex validators reach a consensus to verify and approve the transaction." },
  { n: "03", title: "Direct Settlement", desc: "Approved funds move directly from Cahex's vault at the destination to the recipient's bank or wallet — no wrapping tokens." },
  { n: "04", title: "Card Acceptance", desc: "Cahex accepts payments directly via Credit/Debit card, bridging traditional finance with blockchain." },
];

const useCases = ["API for any platform", "SDK for Applications", "Checkout Pages", "TRON to Fiat Ramp"];

const Work = () => {
  return (
    <section className="section px-6 py-24 max-w-7xl mx-auto">
      <div
        className="rounded-3xl p-12 relative overflow-hidden"
        style={{
          background: "linear-gradient(135deg, #0d1120, #06080f)",
          border: "1px solid rgba(255,255,255,0.06)",
        }}
      >
        <div className="absolute inset-0 grid-bg opacity-30" />
        <div
          className="absolute"
          style={{
            top: 0, right: 0,
            width: "400px", height: "400px",
            background: "radial-gradient(ellipse at top right, rgba(79,142,247,0.08) 0%, transparent 60%)",
          }}
        />

        <div className="relative z-10">
          <div className="badge mb-6">
            <span className="badge-dot" />
            How it Works
          </div>

          <h2
            className="font-syne font-bold mb-4"
            style={{ fontSize: "clamp(32px, 4vw, 52px)", color: "#e8eaf0" }}
          >
            How <span className="grad-text">CAHEX</span> Works?
          </h2>
          <p
            className="max-w-2xl mb-16 text-base"
            style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif", lineHeight: 1.7 }}
          >
            As an infrastructure-agnostic protocol, CAHEX Network can be viewed as a bridgeless bridge between different financial ecosystems, simplifying the process for merchants to accept TRON TRC-20 payments and other crypto payments.
          </p>

          {/* Steps */}
          <div className="grid md:grid-cols-2 gap-5 mb-16">
            {steps.map(({ n, title, desc }) => (
              <div
                key={n}
                className="glow-box rounded-2xl p-6 flex gap-5 transition-all duration-300 cursor-default"
                style={{ background: "rgba(255,255,255,0.02)" }}
              >
                <div
                  className="font-mono-space font-bold text-lg flex-shrink-0 mt-0.5 grad-text"
                  style={{ minWidth: "36px" }}
                >
                  {n}
                </div>
                <div>
                  <div className="font-syne font-semibold text-white mb-2">{title}</div>
                  <div
                    className="text-sm leading-relaxed"
                    style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif" }}
                  >
                    {desc}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="grad-divider mb-10" />

          {/* Where to use */}
          <div>
            <h3
              className="font-syne font-bold text-xl mb-6"
              style={{ color: "#e8eaf0" }}
            >
              Where to use it?
            </h3>
            <div className="flex flex-wrap gap-3">
              {useCases.map((uc) => (
                <div
                  key={uc}
                  className="px-5 py-2.5 rounded-xl text-sm font-syne font-medium transition-all duration-200 cursor-default"
                  style={{
                    background: "rgba(82,198,168,0.06)",
                    border: "1px solid rgba(82,198,168,0.18)",
                    color: "#52c6a8",
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background = "rgba(82,198,168,0.12)"; e.currentTarget.style.boxShadow = "0 0 20px rgba(82,198,168,0.15)"; }}
                  onMouseLeave={e => { e.currentTarget.style.background = "rgba(82,198,168,0.06)"; e.currentTarget.style.boxShadow = "none"; }}
                >
                  {uc}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Work;
